import type { LanguagePack } from './types'

export const or: LanguagePack = {
  navSaved: 'ସେଭ୍ କରାଯାଇଛି',
  navInfo: 'ସୂଚନା',
  homeTitle: 'ଆପଣଙ୍କ କାଗଜର ଗୋଟିଏ ଫଟୋ ଉଠାନ୍ତୁ',
  homeHint: 'ସମଝୋ କହିଦେବ କାଗଜରେ କ’ଣ ଲେଖାଅଛି ଆଉ ଏହାପରେ ଆପଣଙ୍କୁ କ’ଣ କରିବାକୁ ହେବ।',
  takePhoto: 'ଫଟୋ ଉଠାନ୍ତୁ',
  uploadFile: 'ଫଟୋ ବା PDF ଦିଅନ୍ତୁ',
  supportedFiles: 'ଫଟୋ (JPG, PNG, WEBP) ବା PDF · 10 MB ପର୍ଯ୍ୟନ୍ତ',
  chooseLanguage: 'କେଉଁ ଭାଷାରେ ବୁଝିବେ',
  privacyLine: 'ଆପଣଙ୍କ କାଗଜ ଏହି ଫୋନରେ ହିଁ ପଢ଼ାଯାଏ। ଆପଣ "ସେଭ୍ କରନ୍ତୁ" ନ ଦବାଇବା ଯାଏଁ କିଛି ସେଭ୍ ହୁଏ ନାହିଁ।',

  previewTitle: 'ଫଟୋଟି ଠିକ୍ ଅଛି ତ?',
  rotate: 'ବୁଲାନ୍ତୁ',
  crop: 'କାଟନ୍ତୁ',
  cropDone: 'ହୋଇଗଲା',
  retake: 'ପୁଣି ଉଠାନ୍ତୁ',
  readNow: 'ପଢ଼ନ୍ତୁ',
  docLanguageLabel: 'କାଗଜଟି କେଉଁ ଭାଷାରେ ଲେଖାଯାଇଛି?',
  docLanguageHint: 'ଇଂରାଜୀ ସବୁବେଳେ ସାଙ୍ଗରେ ପଢ଼ାଯାଏ।',

  stepCheck: 'ଫଟୋଟି ଦେଖାଯାଉଛି…',
  stepRead: 'କାଗଜଟି ପଢ଼ାଯାଉଛି…',
  stepExtract: 'ଦରକାରୀ କଥାଗୁଡ଼ିକ ଖୋଜାଯାଉଛି…',
  stepExplain: 'ଓଡ଼ିଆରେ ବୁଝାଯାଉଛି…',
  firstTimeNote: 'ପ୍ରଥମ ଥର ଟିକେ ବେଶି ସମୟ ଲାଗିବ, କାରଣ ପଢ଼ିବା ଟୁଲ୍ ଡାଉନଲୋଡ୍ ହେଉଛି।',
  cancel: 'ବାତିଲ୍ କରନ୍ତୁ',

  errBadImage: 'ଫଟୋଟି ଟିକେ ଅସ୍ପଷ୍ଟ। ଦୟାକରି ଆଉ ଗୋଟିଏ ସଫା ଫଟୋ ଉଠାନ୍ତୁ।',
  errNoText: 'ସମଝୋ ଏହି କାଗଜରେ ଲେଖା କିଛି ପାଇଲା ନାହିଁ।',
  errUnclearPart: 'ଏହି ଅଂଶଟି ସମଝୋ ଠିକ୍ ଭାବେ ପଢ଼ିପାରିଲା ନାହିଁ।',
  errUnsupportedLanguage: 'ଏହି ଭାଷା ଏବେ ଚାଲୁ ହୋଇନାହିଁ।',
  errLongDocument: 'ଏହି କାଗଜଟି ବହୁତ ଲମ୍ବା। ପ୍ରଥମେ ଦରକାରୀ ପୃଷ୍ଠାଗୁଡ଼ିକ ବାଛନ୍ତୁ।',
  errFileType: 'ଦୟାକରି ଗୋଟିଏ ଫଟୋ (JPG, PNG, WEBP) ବା PDF ବାଛନ୍ତୁ।',
  errFileSize: 'ଏହି ଫାଇଲ୍ 10 MB ରୁ ବଡ଼। ଦୟାକରି ଛୋଟ ଫାଇଲ୍ ବାଛନ୍ତୁ।',
  errGeneric: 'କିଛି ଗଣ୍ଡଗୋଳ ହୋଇଗଲା। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
  errOcrDownload: 'ପଢ଼ିବା ଟୁଲ୍ ଡାଉନଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ। ଥରେ ଇଣ୍ଟରନେଟ୍ ଚାଲୁ କରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
  warnDark: 'ଫଟୋଟି ଅନ୍ଧାର ଦେଖାଯାଉଛି। ଭଲ ଆଲୁଅରେ ଉଠାଯାଇଥିବା ଫଟୋ ଭଲ ପଢ଼ାଯାଏ।',
  warnBlurry: 'ଫଟୋଟି ଝାପସା ଦେଖାଯାଉଛି। ଫୋନକୁ ସ୍ଥିର ରଖି ପୁଣି ଉଠାନ୍ତୁ।',
  warnSmall: 'ଫଟୋଟି ବହୁତ ଛୋଟ। କାଗଜର ପାଖରୁ ଫଟୋ ଉଠାନ୍ତୁ।',
  tryAgain: 'ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ',

  pickPagesHint: (max) => `ବେଶୀରେ ବେଶୀ ${max}ଟି ପୃଷ୍ଠା ବାଛନ୍ତୁ।`,
  pageLabel: (n) => `ପୃଷ୍ଠା ${n}`,
  readSelectedPages: (n) => `${n}ଟି ପୃଷ୍ଠା ପଢ଼ନ୍ତୁ`,

  typeSure: (name) => `ଏହା ${name} ପରି ଲାଗୁଛି।`,
  typeMaybe: (name) => `ଏହା ବୋଧହୁଏ ${name}, କିନ୍ତୁ ସମଝୋ ପୂରା ନିଶ୍ଚିତ ନୁହେଁ।`,
  typeUnknown: 'ଏହା କେଉଁ ପ୍ରକାରର କାଗଜ, ସମଝୋ ପୂରା ନିଶ୍ଚିତ ନୁହେଁ।',
  docTypes: {
    income_certificate: { name: 'ଆୟ ପ୍ରମାଣପତ୍ର (ଇନକମ୍ ସାର୍ଟିଫିକେଟ୍)', about: 'ଏଥିରେ ସରକାରୀ ରେକର୍ଡ ଅନୁସାରେ କୌଣସି ବ୍ୟକ୍ତି ବା ପରିବାରର ଆୟ ଲେଖାଥାଏ।' },
    caste_certificate: { name: 'ଜାତି ପ୍ରମାଣପତ୍ର', about: 'ଏଥିରେ ଲେଖାଥାଏ ବ୍ୟକ୍ତି କେଉଁ ଜାତି ବା ବର୍ଗର।' },
    domicile_certificate: { name: 'ବାସିନ୍ଦା ପ୍ରମାଣପତ୍ର', about: 'ଏଥିରେ ଲେଖାଥାଏ ବ୍ୟକ୍ତି ସ୍ଥାୟୀ ଭାବେ କେଉଁଠି ରହନ୍ତି।' },
    birth_certificate: { name: 'ଜନ୍ମ ପ୍ରମାଣପତ୍ର', about: 'ଏହା ଜନ୍ମର ସରକାରୀ ରେକର୍ଡ।' },
    death_certificate: { name: 'ମୃତ୍ୟୁ ପ୍ରମାଣପତ୍ର', about: 'ଏହା ମୃତ୍ୟୁର ସରକାରୀ ରେକର୍ଡ।' },
    electricity_bill: { name: 'ବିଜୁଳି ବିଲ୍', about: 'ଏଥିରେ କେତେ ବିଜୁଳି ଖର୍ଚ୍ଚ ହୋଇଛି ଆଉ କେତେ ଟଙ୍କା ଦେବାକୁ ହେବ, ତାହା ଲେଖାଥାଏ।' },
    water_bill: { name: 'ପାଣି ବିଲ୍', about: 'ଏଥିରେ ପାଣି ପାଇଁ ଦେବାକୁ ଥିବା ଟଙ୍କା ଲେଖାଥାଏ।' },
    ration_card: { name: 'ରାସନ କାର୍ଡ ବା ରାସନ ସୂଚନା', about: 'ଏହା ସରକାରୀ ଦୋକାନରୁ ରାସନ ପାଇବା ବିଷୟରେ।' },
    aadhaar: { name: 'ଆଧାର ସମ୍ବନ୍ଧୀୟ କାଗଜ', about: 'ଏହା ଆଧାର ନମ୍ବର ବା ଆଧାର ତଥ୍ୟ ବିଷୟରେ।' },
    pan_card: { name: 'ପାନ୍ ସମ୍ବନ୍ଧୀୟ କାଗଜ', about: 'ଏହା ପାନ୍ (ଟିକସ ପରିଚୟ) ନମ୍ବର ବିଷୟରେ।' },
    bank_notice: { name: 'ବ୍ୟାଙ୍କ ଚିଠି', about: 'ଏହା ବ୍ୟାଙ୍କରୁ ଆସିଥିବା ଚିଠି ବା ସୂଚନା।' },
    loan_notice: { name: 'ଋଣ (ଲୋନ୍) ସୂଚନା', about: 'ଏହା କୌଣସି ଲୋନ୍ ବା ବାକି ଟଙ୍କା ବିଷୟରେ।' },
    income_tax_notice: { name: 'ଆୟକର (ଇନକମ୍ ଟ୍ୟାକ୍ସ) ସୂଚନା', about: 'ଏହା ଆୟକର ବିଭାଗରୁ ଆସିଛି।' },
    pension: { name: 'ପେନସନ୍ ଚିଠି', about: 'ଏହା ପେନସନ୍ ବିଷୟରେ।' },
    court_notice: { name: 'କୋର୍ଟ ବା ଆଇନଗତ ନୋଟିସ୍', about: 'ଏହା କୋର୍ଟରୁ ଆସିଛି ବା କୌଣସି ଆଇନ ମାମଲା ବିଷୟରେ। ଏହାକୁ ଗୁରୁତ୍ୱ ଦିଅନ୍ତୁ।' },
    land_record: { name: 'ଜମି ରେକର୍ଡ', about: 'ଏହା ଜମିର ମାଲିକାନା ବା ଜମି ତଥ୍ୟ ବିଷୟରେ।' },
    property_tax: { name: 'ଘର ଟିକସ (ପ୍ରପର୍ଟି ଟ୍ୟାକ୍ସ) ବିଲ୍', about: 'ଏହା ଘର ବା ସମ୍ପତ୍ତିର ଟିକସ ବିଷୟରେ।' },
    scholarship: { name: 'ବୃତ୍ତି (ସ୍କଲାରସିପ୍) ଚିଠି', about: 'ଏହା ପାଠପଢ଼ା ପାଇଁ ମିଳୁଥିବା ବୃତ୍ତି ବିଷୟରେ।' },
    farmer_scheme: { name: 'ଚାଷୀ ଯୋଜନା ଚିଠି', about: 'ଏହା ଚାଷୀଙ୍କ ପାଇଁ କୌଣସି ଯୋଜନା ବା ସାହାଯ୍ୟ ବିଷୟରେ।' },
    school_letter: { name: 'ସ୍କୁଲ ଚିଠି', about: 'ଏହା ସ୍କୁଲରୁ ଆସିଛି ବା ପାଠପଢ଼ା ବିଷୟରେ।' },
    marksheet: { name: 'ମାର୍କସିଟ୍ ବା ରେଜଲ୍ଟ', about: 'ଏଥିରେ ପରୀକ୍ଷାର ନମ୍ବର ବା ରେଜଲ୍ଟ ଲେଖାଅଛି।' },
    insurance: { name: 'ବୀମା କାଗଜ', about: 'ଏହା କୌଣସି ବୀମା ପଲିସି ବିଷୟରେ।' },
    traffic_challan: { name: 'ଟ୍ରାଫିକ୍ ଚାଲାଣ', about: 'ଏହା ଟ୍ରାଫିକ୍ ବା ଗାଡ଼ି ନିୟମ ଭାଙ୍ଗିବା ପାଇଁ ଜୋରିମାନା।' },
    job_notice: { name: 'ଚାକିରି ବା ପରୀକ୍ଷା ସୂଚନା', about: 'ଏହା ସରକାରୀ ଚାକିରି, ନିଯୁକ୍ତି ବା ତାହାର ପରୀକ୍ଷା ବିଷୟରେ।' },
    application_receipt: { name: 'ଆବେଦନ ରସିଦ', about: 'ଏଥିରୁ ଜଣାପଡ଼େ ଯେ ଆବେଦନ ଜମା ହୋଇଛି।' },
    application_decision: { name: 'ଆବେଦନ ବିଷୟରେ ଚିଠି', about: 'ଏଥିରେ କୌଣସି ଆବେଦନର ନିଷ୍ପତ୍ତି ବା ଖବର ଦିଆଯାଇଛି।' },
    government_notice: { name: 'ସରକାରୀ ନୋଟିସ୍', about: 'ଏହା କୌଣସି ସରକାରୀ ଅଫିସର ନୋଟିସ୍ ବା ଆଦେଶ।' },
    lab_report: { name: 'ଡାକ୍ତରୀ ପରୀକ୍ଷା ରିପୋର୍ଟ', about: 'ଏଥିରେ ରକ୍ତ କିମ୍ବା ଅନ୍ୟ ଡାକ୍ତରୀ ପରୀକ୍ଷାର ଫଳାଫଳ ଅଛି।' },
    rental_agreement: { name: 'ଭଡ଼ା ଚୁକ୍ତିନାମା', about: 'ଏହା ଘର ମାଲିକ ଓ ଭଡ଼ାଟିଆଙ୍କ ମଧ୍ୟରେ ଚୁକ୍ତିନାମା।' },
    loan_agreement: { name: 'ଋଣ ଚୁକ୍ତିନାମା', about: 'ଏଥିରେ ଋଣର ସର୍ତ୍ତ ଅଛି: ସୁଧ, EMI ଓ ଶୁଳ୍କ।' },
    contract: { name: 'ଏକ ଚୁକ୍ତିନାମା', about: 'ଏହା ଏକ ଚୁକ୍ତିନାମା, ଯାହାର ସର୍ତ୍ତ ଦୁଇ ପକ୍ଷ ମାନିବାକୁ ପଡ଼େ।' },
    unknown: { name: 'ଗୋଟିଏ କାଗଜ', about: '' }
  },

  seedhiBaat: 'ସିଧା କଥାରେ',
  docSays: 'କାଗଜରେ ଲେଖାଅଛି',
  samjhoSays: 'ସମଝୋ ବୁଝାଉଛି',
  unclearText: 'ଏହି ଅଂଶ ସଫା ପଢ଼ାଗଲା ନାହିଁ — ଦୟାକରି ମୂଳ କାଗଜ ଦେଖନ୍ତୁ।',

  aboutPerson: (name) => `ଏହି କାଗଜ ଏହାଙ୍କ ବିଷୟରେ: ${name}।`,
  issuedBy: (authority) => `ଏହା ଏଠାରୁ ଆସିଛି: ${authority}।`,
  status: {
    approved: 'ଆବେଦନ ମଞ୍ଜୁର ହୋଇଛି।',
    rejected: 'ଆବେଦନ ନାମଞ୍ଜୁର (ରିଜେକ୍ଟ) ହୋଇଛି।',
    pending: 'ଆବେଦନର କାମ ଏବେ ବି ଚାଲିଛି। ଏଯାଏଁ କୌଣସି ନିଷ୍ପତ୍ତି ହୋଇନାହିଁ।',
    cancelled: 'ଏହାକୁ ବାତିଲ୍ କରାଯାଇଛି।'
  },
  dateSentence: {
    deadline: (d) => `ଶେଷ ତାରିଖ: ${d}।`,
    due: (d) => `ଟଙ୍କା ଦେବାର ଶେଷ ତାରିଖ: ${d}।`,
    hearing: (d) => `କାଗଜରେ ହାଜର ହେବା ପାଇଁ ଏହି ତାରିଖ ଦିଆଯାଇଛି: ${d}।`,
    issue: (d) => `ଏହି କାଗଜ ${d} ତାରିଖରେ ଦିଆଯାଇଥିଲା।`,
    validity: (d) => `ଏହା ${d} ପର୍ଯ୍ୟନ୍ତ ବୈଧ।`,
    birth: (d) => `ଜନ୍ମ ତାରିଖ ଲେଖାଅଛି: ${d}।`,
    other: (d) => `ଗୋଟିଏ ତାରିଖ ଲେଖାଅଛି: ${d}।`
  },
  daysLeft: (days) => `ଆଉ ${days} ଦିନ ବାକି ଅଛି।`,
  dueToday: 'ଏହି ତାରିଖ ଆଜି।',
  datePassed: 'ଧ୍ୟାନ ଦିଅନ୍ତୁ: ଏହି ତାରିଖ ବିତିଯାଇଛି।',
  amountSentence: {
    payable: (a) => `ଦେବାକୁ ଥିବା ଟଙ୍କା: ${a}।`,
    income: (a) => `ଲେଖାଥିବା ଆୟ: ${a}।`,
    fine: (a) => `ଜୋରିମାନା ବା ଡେରି ପାଇଁ ଚାର୍ଜ ଲେଖାଅଛି: ${a}।`,
    fee: (a) => `ଫି ଲେଖାଅଛି: ${a}।`,
    sanctioned: (a) => `ମଞ୍ଜୁର ହୋଇଥିବା ବା ପଠାଯାଇଥିବା ଟଙ୍କା: ${a}।`,
    other: (a) => `ଗୋଟିଏ ଟଙ୍କା ପରିମାଣ ଲେଖାଅଛି: ${a}।`
  },
  actionsPointer: 'କାଗଜରେ ଆପଣଙ୍କୁ କିଛି କରିବାକୁ କୁହାଯାଇଛି। ତଳେ "ଆପଣଙ୍କୁ କ’ଣ କରିବାକୁ ହେବ" ଦେଖନ୍ତୁ।',
  noActionFound: 'କାଗଜରେ ଆପଣଙ୍କୁ କିଛି କରିବାକୁ କୁହାଯାଇଛି କି ନାହିଁ, ତାହା ସଫା ଲେଖାନାହିଁ।',
  keepSafe: 'ଏହି କାଗଜକୁ ଯତ୍ନରେ ରଖନ୍ତୁ।',
  doBefore: (d) => `${d} ତାରିଖ ଆଗରୁ ଏହି କାମ କରନ୍ତୁ।`,
  bringDocs: (list) => `ଏହି କାଗଜଗୁଡ଼ିକ ପ୍ରସ୍ତୁତ ରଖନ୍ତୁ: ${list}।`,
  contactFor: (c) => `କିଛି ପଚାରିବାର ଥିଲେ ଏଠାରେ ଯୋଗାଯୋଗ କରନ୍ତୁ: ${c}।`,
  warningPointer: 'କାଗଜରେ ଗୋଟିଏ ଚେତାବନୀ ଲେଖାଅଛି। ତାହାକୁ ଧ୍ୟାନ ଦେଇ ପଢ଼ନ୍ତୁ।',
  rejectedNext: 'ଯଦି ଆପଣଙ୍କୁ ଲାଗୁଛି ଯେ ଭୁଲ୍ ହୋଇଛି, ତେବେ ଯେଉଁ ଅଫିସରୁ ଏହି ଚିଠି ଆସିଛି, ସେଠାରେ ପଚାରନ୍ତୁ।',
  lowQuality: 'ଫଟୋଟି ବହୁତ ସଫା ନଥିଲା, ତେଣୁ କିଛି କଥା ଭୁଲ୍ ପଢ଼ାଯାଇଥାଇପାରେ। ମୂଳ କାଗଜ ସହ ମିଳାଇ ଦେଖନ୍ତୁ।',

  cardTodo: 'ଆପଣଙ୍କୁ କ’ଣ କରିବାକୁ ହେବ',
  cardDates: 'ଦରକାରୀ ତାରିଖ',
  cardAmount: 'ଟଙ୍କା',
  cardWhere: 'କେଉଁଠିକି ଯିବାକୁ ହେବ',
  cardWarnings: 'ସାବଧାନ',
  cardDocs: 'କେଉଁ କାଗଜ ଦରକାର',
  cardPerson: 'କାହା ବିଷୟରେ',
  cardFrom: 'କିଏ ପଠାଇଛି',
  cardNumbers: 'ଦରକାରୀ ନମ୍ବର',
  cardContact: 'ଯୋଗାଯୋଗ',
  refKinds: {
    application: 'ଆବେଦନ ନମ୍ବର',
    certificate: 'ପ୍ରମାଣପତ୍ର ନମ୍ବର',
    consumer: 'କନଜ୍ୟୁମର ନମ୍ବର',
    account: 'ଆକାଉଣ୍ଟ ନମ୍ବର',
    case: 'କେସ୍ ନମ୍ବର',
    reference: 'ଚିଠି ନମ୍ବର',
    registration: 'ରେଜିଷ୍ଟ୍ରେସନ୍ ନମ୍ବର',
    receipt: 'ରସିଦ ନମ୍ବର',
    other: 'ନମ୍ବର'
  },
  requiredDocNames: {
    aadhaar: 'ଆଧାର କାର୍ଡ',
    pan: 'ପାନ୍ କାର୍ଡ',
    ration_card: 'ରାସନ କାର୍ଡ',
    voter_id: 'ଭୋଟର କାର୍ଡ',
    passbook: 'ବ୍ୟାଙ୍କ ପାସବୁକ୍',
    photo: 'ଫଟୋ',
    income_certificate: 'ଆୟ ପ୍ରମାଣପତ୍ର',
    caste_certificate: 'ଜାତି ପ୍ରମାଣପତ୍ର',
    domicile_certificate: 'ବାସିନ୍ଦା ପ୍ରମାଣପତ୍ର',
    birth_certificate: 'ଜନ୍ମ ପ୍ରମାଣପତ୍ର',
    land_record: 'ଜମି ରେକର୍ଡ',
    electricity_bill: 'ବିଜୁଳି ବିଲ୍',
    address_proof: 'ଠିକଣା ପ୍ରମାଣ',
    id_proof: 'ପରିଚୟ ପ୍ରମାଣ',
    affidavit: 'ଶପଥପତ୍ର (ଆଫିଡେଭିଟ୍)',
    application_form: 'ଆବେଦନ ଫର୍ମ'
  },

  voiceDownloadNote: 'ପ୍ରଥମ ଥର ସ୍ୱର ଡାଉନଲୋଡ ହେଉଛି (ପ୍ରାୟ 58 MB)। ତା ପରେ ଇଣ୍ଟରନେଟ ବିନା ମଧ୍ୟ ଚାଲିବ।',

  listen: 'ଶୁଣନ୍ତୁ',
  pause: 'ଅଟକାନ୍ତୁ',
  resume: 'ବାକି ଶୁଣନ୍ତୁ',
  stop: 'ବନ୍ଦ କରନ୍ତୁ',
  noVoice: 'ଏହି ଫୋନରେ ଓଡ଼ିଆ ସ୍ୱର (ଭଏସ୍) ନାହିଁ।',
  noVoiceHint: 'ଫୋନର ସେଟିଂସରେ (Text-to-speech) ସ୍ୱର ଯୋଡ଼ିପାରିବେ, ବା ଅନ୍ୟ ଭାଷାରେ ଶୁଣନ୍ତୁ।',
  listenInHindi: 'ହିନ୍ଦୀରେ ଶୁଣନ୍ତୁ',
  listenInEnglish: 'ଇଂରାଜୀରେ ଶୁଣନ୍ତୁ',
  noSpeechSupport: 'ଏହି ବ୍ରାଉଜର୍ ପଢ଼ି ଶୁଣାଇପାରିବ ନାହିଁ।',

  disclaimer: 'ସମଝୋ ଆପଣଙ୍କ କାଗଜକୁ ସହଜ କରି ବୁଝାଏ। ଦରକାରୀ କଥାଗୁଡ଼ିକ ସବୁବେଳେ ମୂଳ କାଗଜ ବା କାଗଜ ଦେଇଥିବା ଅଫିସ ସହ ମିଳାଇ ଦେଖନ୍ତୁ। ସମଝୋ ସରକାରୀ ସେବା ନୁହେଁ ଏବଂ ଏହା ଆଇନଗତ ପରାମର୍ଶ ନୁହେଁ।',
  fullText: 'ସମଝୋ କ’ଣ ପଢ଼ିଲା',
  fullTextHint: 'ରଙ୍ଗ ହୋଇଥିବା ଧାଡ଼ିଗୁଡ଼ିକ ସଫା ପଢ଼ାଯାଇପାରିଲା ନାହିଁ।',
  newDocument: 'ନୂଆ କାଗଜ',
  save: 'ଏହି ଫୋନରେ ସେଭ୍ କରନ୍ତୁ',
  saved: 'ଏହି ଫୋନରେ ସେଭ୍ ହୋଇଗଲା',
  share: 'ସେୟାର୍ କରନ୍ତୁ',
  copied: 'କପି ହୋଇଗଲା',
  translateLines: 'କାଗଜର ଇଂରାଜୀ ଧାଡ଼ିଗୁଡ଼ିକ ଓଡ଼ିଆରେ ଦେଖନ୍ତୁ',
  helperMode: 'ସହାୟକ ମୋଡ୍',
  helperModeHint: 'ଅନ୍ୟମାନଙ୍କ ପାଇଁ କାଗଜ ପଢ଼ି ଦେଉଥିବା ଲୋକଙ୍କ ପାଇଁ (CSC, NGO, ସ୍ୱେଚ୍ଛାସେବୀ)। ଏଥିରେ ସେଭ୍ ବନ୍ଦ ରହେ, ଏବଂ "ପରବର୍ତ୍ତୀ ବ୍ୟକ୍ତି" ଦବାଇଲେ ସବୁ ଲିଭିଯାଏ।',
  nextPerson: 'ପରବର୍ତ୍ତୀ ବ୍ୟକ୍ତି',
  listenMode: 'ଶୁଣିବା ମୋଡ୍',
  listenModeHint: 'ବୁଝାମଣା ପ୍ରସ୍ତୁତ ହେବା ମାତ୍ରେ ସମଝୋ ତାହାକୁ ନିଜେ ପଢ଼ି ଶୁଣାଏ।',
  settingsTitle: 'ସେଟିଂସ୍',
  shareVoiceNote: 'ଭଏସ୍ ନୋଟ୍ ପଠାନ୍ତୁ',
  makingVoiceNote: 'ଭଏସ୍ ନୋଟ୍ ତିଆରି ହେଉଛି…',
  voiceNoteFailed: 'ଏହି ଫୋନରେ ଭଏସ୍ ନୋଟ୍ ତିଆରି ହୋଇପାରିଲା ନାହିଁ।',
  translateOtherLines: 'କାଗଜର ଅନ୍ୟ ଭାଷାର ଧାଡ଼ିଗୁଡ଼ିକ ଓଡ଼ିଆରେ ଦେଖନ୍ତୁ',
  translateAiNote: 'ଯେଉଁ ଧାଡ଼ିଗୁଡ଼ିକ ଇଂରାଜୀରେ ନାହିଁ, ସେଗୁଡ଼ିକୁ ଏକ AI ସେବା (Groq) ଅନୁବାଦ କରେ।',
  translateConsent: 'ଅନୁବାଦ ପାଇଁ ଏହି ଧାଡ଼ିଗୁଡ଼ିକ ଇଣ୍ଟରନେଟ୍ ଦେଇ ସମଝୋ ସର୍ଭରକୁ ପଠାଯିବ। ସେଠାରେ ସେଭ୍ ହୁଏ ନାହିଁ। ଆଧାର ଓ ଫୋନ ଭଳି ନମ୍ବର ଆଗରୁ ହଟାଇ ଦିଆଯାଏ।',
  translateConfirm: 'ହଁ, ଅନୁବାଦ କରନ୍ତୁ',
  translating: 'ଅନୁବାଦ ହେଉଛି…',
  translateNote: 'ମେସିନ୍ ଅନୁବାଦ — ଭୁଲ୍ ଥାଇପାରେ।',
  translateFailed: 'ଏବେ ଅନୁବାଦ ହୋଇପାରୁନାହିଁ।',
  retryRotated: 'ଫଟୋ ବୁଲାଇ ପୁଣି ପଢ଼ନ୍ତୁ',

  addToCalendar: 'କ୍ୟାଲେଣ୍ଡରରେ ମନେପକାଇବା ଯୋଡ଼ନ୍ତୁ',
  askTitle: 'ଏହି କାଗଜ ବିଷୟରେ ପଚାରନ୍ତୁ',
  askHint: 'ନିଜ ଭାଷାରେ ପଚାରନ୍ତୁ। ସମଝୋ ଆପଣଙ୍କ କାଗଜରୁ ଉତ୍ତର ଦେବ — ଆଉ ସେଠାରେ ନଥିଲେ, କେବଳ ସରକାରୀ ୱେବସାଇଟରୁ।',
  askPlaceholder: 'ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଲେଖନ୍ତୁ ବା କୁହନ୍ତୁ…',
  askSend: 'ପଚାରନ୍ତୁ',
  askMic: 'କହି ପଚାରନ୍ତୁ',
  askListening: 'ଶୁଣୁଛି… ଏବେ କୁହନ୍ତୁ',
  askWebToggle: 'ଦରକାର ହେଲେ ସରକାରୀ ୱେବସାଇଟ ମଧ୍ୟ ଦେଖନ୍ତୁ',
  askConsent: 'ଉତ୍ତର ଦେବା ପାଇଁ ଏହି କାଗଜର ଲେଖା ଓ ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଇଣ୍ଟରନେଟ୍ ଦେଇ ସମଝୋ ସର୍ଭର ଓ ଏକ AI ସେବାକୁ (Groq) ପଠାଯିବ। ଆଧାର, ପାନ୍, ଫୋନ ନମ୍ବର ଓ ଇମେଲ ଆଗରୁ ହଟାଇ ଦିଆଯାଏ। କିଛି ସେଭ୍ ହୁଏ ନାହିଁ।',
  askOfficialOnly: 'କେବଳ ସରକାରୀ ୱେବସାଇଟ ଦେଖାଯାଏ, ଯେପରି:',
  askConsentConfirm: 'ଠିକ ଅଛି, ପଚାରନ୍ତୁ',
  askThinkingDoc: 'ଆପଣଙ୍କ କାଗଜ ପଢ଼ୁଛି',
  askThinkingWeb: 'ସରକାରୀ ୱେବସାଇଟ ଦେଖୁଛି',
  askFromDoc: 'ଆପଣଙ୍କ କାଗଜରୁ',
  askFromWeb: 'ସରକାରୀ ୱେବସାଇଟରୁ',
  askNotFound: 'ସମଝୋ ଏହା ଆପଣଙ୍କ କାଗଜରେ କିମ୍ବା ସରକାରୀ ୱେବସାଇଟରେ ପାଇଲା ନାହିଁ। ଯେଉଁ ଅଫିସ ଏହି କାଗଜ ପଠାଇଛି, ସେମାନଙ୍କୁ ପଚାରନ୍ତୁ।',
  askUnverified: 'ସମଝୋ ଏହାକୁ କାଗଜର କୌଣସି ସଠିକ ଧାଡ଼ି ସହ ମିଳାଇ ପାରିଲା ନାହିଁ। କାଗଜ ଦେଖି ଯାଞ୍ଚ କରନ୍ତୁ।',
  askSources: 'ଉତ୍ସ',
  askOfficial: 'ସରକାରୀ',
  askFailed: 'ଏବେ ଉତ୍ତର ମିଳିଲା ନାହିଁ। ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
  askBusy: 'ଏବେ ବହୁତ ପ୍ରଶ୍ନ ଆସୁଛି। ଗୋଟିଏ ମିନିଟ ଅପେକ୍ଷା କରି ପୁଣି ପଚାରନ୍ତୁ।',
  askAiNote: 'ଏହି ଉତ୍ତରଗୁଡ଼ିକ AI ଲେଖିଛି, ଭୁଲ ଥାଇପାରେ। ଜରୁରୀ କଥା ଅଫିସରୁ ନିଶ୍ଚିତ କରନ୍ତୁ।',
  askTryNext: 'ଆପଣ ଏହା ମଧ୍ୟ ପଚାରିପାରିବେ:',
  askJump: 'ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ',
  askSuggest: {
    fillForm: 'ଏହି ଫର୍ମ କିପରି ପୂରଣ କରିବି? ପ୍ରତ୍ୟେକ ଘର ବୁଝାନ୍ତୁ।',
    first: 'ମୁଁ ପ୍ରଥମେ କ’ଣ କରିବା ଉଚିତ?',
    deadline: 'ଶେଷ ତାରିଖ ପାର ହୋଇଗଲେ କ’ଣ ହେବ?',
    pay: 'ଏହା କିପରି ଓ କେଉଁଠି ଜମା କରିବି?',
    papers: 'ଏହି କାଗଜଗୁଡ଼ିକ କେଉଁଠୁ ପାଇବି?',
    rejected: 'ଏହା କାହିଁକି ବାତିଲ ହେଲା, ଆଉ ଏବେ ମୁଁ କ’ଣ କରିପାରିବି?',
    meaning: 'ଏହି କାଗଜକୁ ବହୁତ ସହଜ ଭାଷାରେ ବୁଝାନ୍ତୁ।',
    contact: 'ଏ ବିଷୟରେ କାହା ସହ ଯୋଗାଯୋଗ କରିବି?',
    schemes: 'ଏହି କାଗଜ ଅନୁସାରେ ମୁଁ କେଉଁ ସରକାରୀ ଯୋଜନା ପାଇଁ ଯୋଗ୍ୟ ହୋଇପାରେ?'
  },

  helpTitle: 'ସାହାଯ୍ୟ ନିଅନ୍ତୁ',
  nearbyTitle: 'ନିକଟତମ ଅଫିସ',
  nearbyNote: 'ଆପଣଙ୍କ ପାଖର ମାନଚିତ୍ର ଖୋଲିବ। ଆପଣଙ୍କ ଲୋକେସନ କେବଳ ମାନଚିତ୍ରକୁ ଯାଏ — ସମଝୋ ତାହା ଦେଖେ ନାହିଁ କି ସେଭ୍ କରେ ନାହିଁ।',
  locating: 'ଆପଣଙ୍କ ଲୋକେସନ ଖୋଜୁଛି…',
  schemesTitle: 'ସରକାରୀ ଯୋଜନା',
  schemesText: 'ଏହି କାଗଜ ଅନୁସାରେ କେଉଁ ଯୋଜନା ଆପଣଙ୍କ କାମରେ ଆସିପାରେ, ସମଝୋ ସରକାରୀ ଯୋଜନା ୱେବସାଇଟରେ ଦେଖିପାରେ।',
  schemesButton: 'ମୋ ପାଇଁ ଯୋଜନା ଖୋଜନ୍ତୁ',
  legalTitle: 'ମାଗଣା ଆଇନଗତ ସାହାଯ୍ୟ',
  legalText: 'ଆଇନ ସେବା ପ୍ରାଧିକରଣରୁ ଆପଣ ମାଗଣା ଓକିଲ ପାଇପାରନ୍ତି — ଯେପରି ମହିଳା, ଶିଶୁ, SC/ST, ଶ୍ରମିକ, ଦିବ୍ୟାଙ୍ଗ ଓ କମ୍ ଆୟର ଲୋକ।',
  legalCall: (n) => `${n}କୁ କଲ୍ କରନ୍ତୁ (ମାଗଣା)`,
  legalNearby: 'ନିକଟତମ ଆଇନ ସେବା ପ୍ରାଧିକରଣ',
  legalMore: 'ଅଧିକ ଆଇନ ସାହାଯ୍ୟ',
  legalAskConsent: 'ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଇଣ୍ଟରନେଟ୍ ଦେଇ ସମଝୋ ସର୍ଭର ଓ ଏକ AI ସେବାକୁ (Groq) ପଠାଯିବ, ଯାହା ଉତ୍ତର କେବଳ ସରକାରୀ ୱେବସାଇଟରେ ଖୋଜେ। ଆଧାର, ପାନ୍, ଫୋନ ନମ୍ବର ଓ ଇମେଲ ଆଗରୁ ହଟାଇ ଦିଆଯାଏ। କିଛି ସେଭ୍ ହୁଏ ନାହିଁ।',
  navLegal: 'ଆଇନ ସାହାଯ୍ୟ'
}
